<script setup lang="ts">
import Skeleton from '@/components/Skeleton.vue'
import { organizationModule } from '@/store/organization/module'
import { userModule } from '@/store/user/module'
import UIKit from '@pocketprep/ui-kit'
import { computed, onBeforeMount } from 'vue'

const { Link: PocketLink, Icon } = UIKit

const version = import.meta.env.VUE_APP_VERSION

const currentUser = computed(() => {
    return userModule.state.user
})

const currentOrg = computed(() => {
    return organizationModule.getters.getCurrentOrganization()
})

onBeforeMount(async () => {
    await organizationModule.actions.fetchCurrentOrganization()
})
</script>

<template>
    <Skeleton class="assignments">
        <template #side>
            <div class="assignments__org-info">
                <div v-if="currentOrg" class="assignments__org-name">
                    {{ currentOrg.name }}
                </div>
                <div v-if="currentUser" class="assignments__user-name">
                    {{ [ currentUser.firstName, currentUser.lastName ].join(' ') }}
                </div>
            </div>
            <div class="assignments__links">
                <PocketLink
                    target="_blank"
                    href="https://help.educators.pocketprep.com"
                    class="assignments__links-help"
                >
                    <Icon type="help" />
                    Help
                </PocketLink>
                <PocketLink
                    target="_blank"
                    href="http://www.pocketprep.com/terms-of-service/"
                    class="assignments__links-terms"
                >
                    <Icon type="lock" />
                    Privacy Policy &amp; Terms of Use
                </PocketLink>
            </div>
            <div v-if="version" class="assignments__version">
                v{{ version }}
            </div>
        </template>
        <RouterView />
    </Skeleton>
</template>

<style lang="scss" scoped>

.assignments {

    &__org-info {
        margin: 35px 0 0 46px;
    }

    &__links {
        position: fixed;
        left: 45px;
        bottom: 100px;
        height: 63px;

        a {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            font-size: 14px;
            line-height: 19px;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    &__org-name {
        color: $ash;
        font-size: 15px;
        line-height: 20px;
        margin-bottom: 7px;
    }

    &__user-name {
        font-size: 20px;
        line-height: 27px;
        font-weight: 600;
    }

    &__links-help svg {
        width: 15px;
        margin-right: 10px;
        margin-left: 3px;
    }

    &__links-terms svg {
        width: 21px;
        margin-right: 7px;
    }

    &__version {
        position: fixed;
        left: 45px;
        bottom: 76px;
        color: $slate-01;
        font-size: 15px;
    }
}
</style>
